<div *ngIf="!isLoading" class="system-menu">
  <nz-tree
    nzBlockNode
    [nzData]="data"
    (nzClick)="handleMenuOnclick($event)"
    [nzTreeTemplate]="nzTreeTemplate"
    [nzSelectedKeys]="defaultKey"
    [nzExpandedKeys]="expandKey"
  >
  </nz-tree>
  <ng-template #nzTreeTemplate let-node let-origin="origin">
    <span
      class="system-menu-item-text"
      [ngClass]="{ 'menu-highlight-text': searchedValue }"
      [innerHtml]="node.title | textHighlight: searchedValue"
    >
    </span>
  </ng-template>
</div>

<app-custom-skeleton
  *ngIf="isLoading"
  [customSkeletonConfig]="skeletonDefaultConfig"
  ngClass="menu-skeleton"
></app-custom-skeleton>
